export const PDF_HEADER = {
    pt: [
        { datakey: 'plannedDate', title: 'Data planejada' },
        { datakey: 'readingTime', title: 'Hora da leitura' },
        { datakey: 'account', title: 'Empresa' },
        { datakey: 'client', title: 'Cliente' },
        { datakey: 'point', title: 'Ponto' },
        { datakey: 'site', title: 'Local' },
        { datakey: 'status', title: 'Status' },
    ],
    en: [
        { datakey: 'plannedDate', title: 'Planned Date' },
        { datakey: 'readingTime', title: 'Reading Time' },
        { datakey: 'account', title: 'Company' },
        { datakey: 'client', title: 'Client' },
        { datakey: 'point', title: 'Checkpoint' },
        { datakey: 'site', title: 'Site' },
        { datakey: 'status', title: 'Status' },
    ],
}
